import React, {Component} from 'react';
import {observer} from 'mobx-react';
import {autorun, action} from 'mobx';
import styles from './styles.css';
import SheetCalculatorStore, {sheetTypeEnum} from './SheetCalculatorStore';
import Measure from 'react-measure';
import './Components/Imposition';

import WhiteSpaceForm from './Components/WhiteSpaceForm';

@observer
export default class SheetCalculator extends Component {
  store = null;
  pixiContainer = null;

  componentDidMount() {
    this.store.rendererStore.setContainer(this.pixiContainer);
  }

  constructor() {
    super();
    this.store = new SheetCalculatorStore();
  }

  handleSheetWidthUpdate = event => this.store.update('sheet', 'width', event.target.value);
  handleSheetHeightUpdate = event => this.store.update('sheet', 'height', event.target.value);
  handleSheetBottomUpdate = event => this.store.update('sheet', 'bottom', event.target.value);
  handleSheetTopUpdate = event => this.store.update('sheet', 'top', event.target.value);
  handleSheetLeftUpdate = event => this.store.update('sheet', 'left', event.target.value);
  handleSheetRightUpdate = event => this.store.update('sheet', 'right', event.target.value);

  handlePageWidthUpdate = event => this.store.update('page', 'width', event.target.value);
  handlePageHeightUpdate = event => this.store.update('page', 'height', event.target.value);
  handlePageAmountUpdate = event => this.store.update('page', 'amount', event.target.value);

  handleBleedHorizontalUpdate = event => this.store.updateBleed('horizontal', event.target.value);
  handleBleedVerticalUpdate = event => this.store.updateBleed('vertical', event.target.value);

  handleCanvasWidthUpdate = contentRect => this.store.updateCanvasWidth(contentRect.bounds.width);

  handleTypeRadioChange = event => this.store.updateType(event.target.value);

  @action handleSetSheet = (width, height, bottom, top, left, right) => {
    this.store.update('sheet', 'width', width);
    this.store.update('sheet', 'height', height);
    this.store.update('sheet', 'bottom', bottom);
    this.store.update('sheet', 'top', top);
    this.store.update('sheet', 'left', left);
    this.store.update('sheet', 'right', right);
  };

  render() {
    const {canvas, sheet, page, bleed, fits, options} = this.store;
    const canvasWidth = canvas.width;
    const canvasHeight = (canvasWidth * sheet.height) / sheet.width;

    return (
      <div>
        <Measure bounds onResize={this.handleCanvasWidthUpdate}>
          {({ measureRef }) =>
            <div ref={measureRef}>
              <div width={canvasWidth} height={canvasHeight} ref={div => this.pixiContainer = div}/>
            </div>
          }
        </Measure>
        <h5>Sheet</h5>
        <div>
          <button onClick={() => this.handleSetSheet(640, 460, 15, 10, 5, 5)}>KBA 640x460</button>
          <button onClick={() => this.handleSetSheet(640, 450, 15, 10, 5, 5)}>KBA 640x450</button>
          <button onClick={() => this.handleSetSheet(720, 520, 15, 10, 5, 5)}>KBA 720x520</button>
          <button onClick={() => this.handleSetSheet(720, 510, 15, 10, 5, 5)}>KBA 720x510</button>
          <button onClick={() => this.handleSetSheet(458, 318, 5, 5, 5, 5)}>DIGI 458x318</button>
          <button onClick={() => this.handleSetSheet(488, 330, 5, 5, 5, 5)}>DIGI 488x330</button>
          <WhiteSpaceForm options={this.store.brochureWhiteSpaces.top}/>
          <p>Width: <input type="number" onChange={this.handleSheetWidthUpdate} value={sheet.width} />mm</p>
          <p>Height: <input type="number" onChange={this.handleSheetHeightUpdate} value={sheet.height} />mm</p>
          <p>Bottom: <input onChange={this.handleSheetBottomUpdate} value={sheet.bottom} />mm</p>
          <p>Top: <input type="number" onChange={this.handleSheetTopUpdate} value={sheet.top} />mm</p>
          <p>Left: <input type="number" onChange={this.handleSheetLeftUpdate} value={sheet.left} />mm</p>
          <p>Right: <input type="number" onChange={this.handleSheetRightUpdate} value={sheet.right} />mm</p>
          <fieldset>
            <legend>Kuidas trükime?</legend>
            <input
              type="radio"
              name="type"
              value={sheetTypeEnum.SHEETWISE}
              checked={options.type === sheetTypeEnum.SHEETWISE}
              onChange={this.handleTypeRadioChange}
            />P/S<br />
            <input
              type="radio"
              name="type"
              value={sheetTypeEnum.WORK_AND_TURN}
              checked={options.type === sheetTypeEnum.WORK_AND_TURN}
              onChange={this.handleTypeRadioChange}
            />Ü/V<br />
            <input
              type="radio"
              name="type"
              value={sheetTypeEnum.WORK_AND_TUMBLE}
              checked={options.type === sheetTypeEnum.WORK_AND_TUMBLE}
              onChange={this.handleTypeRadioChange}
            />Ü/P<br />
          </fieldset>
        </div>
        <h5>Page</h5>
        <div>
          <p>Width: <input type="number" onChange={this.handlePageWidthUpdate} value={page.width} />mm</p>
          <p>Height: <input type="number" onChange={this.handlePageHeightUpdate} value={page.height} />mm</p>
          <p>Amount: <input type="number" onChange={this.handlePageAmountUpdate} value={page.amount} />mm</p>
        </div>
        <h5>Bleeds, comma separated</h5>
        <div>
          <p>Horizontal(left to right): <input onChange={this.handleBleedHorizontalUpdate} value={bleed.horizontal} /></p>
          <p>Vertical(top to bottom): <input onChange={this.handleBleedVerticalUpdate} value={bleed.vertical} /></p>
        </div>
        <h5>Fits</h5>
        <div>
          <p>Fits: {fits.total} {fits.type} ({fits.horizontal}x{fits.vertical})</p>
          <p>Wasted paper: {Math.round((sheet.area - (page.area * fits.total)) * 100 / sheet.area * 100) / 100}%</p>
        </div>

      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/views/SheetCalculator/SheetCalculator.js